import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListingDirectories = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_13362_757)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
					fill: "url(#paint0_linear_13362_757)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.0003 15.8332C13.222 15.8332 15.8337 13.2215 15.8337 9.99984C15.8337 6.77818 13.222 4.1665 10.0003 4.1665C6.77866 4.1665 4.16699 6.77818 4.16699 9.99984C4.16699 13.2215 6.77866 15.8332 10.0003 15.8332Z",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.0003 4.1665C8.50246 5.73926 7.66699 7.82794 7.66699 9.99984C7.66699 12.1717 8.50246 14.2604 10.0003 15.8332C11.4982 14.2604 12.3337 12.1717 12.3337 9.99984C12.3337 7.82794 11.4982 5.73926 10.0003 4.1665Z",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.16699 10H15.8337",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_13362_757",
			x1: 10,
			y1: 0,
			x2: 10,
			y2: 20,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFD08A" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF6A00"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13362_757",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgListingDirectories);
export { ForwardRef as ReactComponent };
